import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../shared/guards/auth.guards';
import { PendingChangesGuard } from '../../shared/guards/pending-changes.guard';
import { Groups } from '../security/model/groups.model';
import { QuestionListComponent } from './components/question-list/question-list.component';

export class QuestionRoutingStates {
  public static readonly VIEW = {
    url: 'issue/:issueId/question'
  };
}

export const QuestionRoutes: Routes = [
  {
    path: QuestionRoutingStates.VIEW.url,
    data: {
      page: {
        title: 'Question List'
      },
      requiresRole: [Groups.CLIENT_ADMIN]
    },
    component: QuestionListComponent,
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard]
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(QuestionRoutes)],
  providers: [PendingChangesGuard]
})
export class QuestionRoutingModule {}
